export class CreateCloudAccountResponse {
    customerId?: string;
    accountId?: string;
    connectAccountId?: string;
    description?: string;
    creationTime?: Date;
    region?: string;
}